export const ICON_SIZE_DEFAULT = 14;
export const ICON_SIZE_LARGE_DEFAULT = 18;

export const SPINNER_SIZE = 16;
export const SPINNER_SIZE_LARGE = 18;
